import { TdsProgress } from '@trv-tds/react'
import styled from 'styled-components'

import './style.css'

const ProgressFlowIndicatorContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 36px;
`

const ProgressFlowIndicator = styled.div`
  width: 100%;
  @media (max-width: 468px) {
    width: 90%;
  }
`

type ProcessFlowProps = {
  active: string
}

const ProcessFlow = (props: ProcessFlowProps) => {
  const steps = new Map(
    [
      ['claims', { name: 'Step 1/3: Find Claim', value: 33 }],
      ['identity', { name: 'Step 2/3: Contact Details', value: 66 }],
      ['upload', { name: 'Step 3/3: Uploads', value: 100 }],
    ]
  )

  const currentStep = steps.get(props.active)

  return (
      <ProgressFlowIndicatorContainer>
        <ProgressFlowIndicator id="progressFlowIndicator">
          {currentStep && (
            <TdsProgress max={100} value={currentStep.value}>
                <span slot="label">{currentStep.name}</span>
            </TdsProgress>
          )}
        </ProgressFlowIndicator>
      </ProgressFlowIndicatorContainer>
  )
}

export { ProcessFlow }
